import { render, staticRenderFns } from "./PrimaryContact.vue?vue&type=template&id=0a28c62b&scoped=true&"
import script from "./PrimaryContact.vue?vue&type=script&lang=js&"
export * from "./PrimaryContact.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryContact.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PrimaryContact.vue?vue&type=style&index=1&id=0a28c62b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28c62b",
  null
  
)

export default component.exports